import Vue from 'vue';
import Vuex from 'vuex';
// import getters from './getters';

import employee from './modules/employee';
import holidayConfig from './modules/holidayConfig';
import project from './modules/project';
import sysAdmin from './modules/sysAdmin';
import customer from "./modules/customer";
import weChat from './modules/wechat'
import department from './modules/department'
import report from './modules/report'
import contract from './modules/contract'
import workHours from './modules/workHours'
import mindInfo from "./modules/mind"
import eteamChance from "./modules/eteamChance"
import projectPerformance from './modules/projectPerformance'

Vue.use(Vuex)

// 创建 store 实例
const store = new Vuex.Store({
    modules: {
        sysAdmin,
        employee,
        customer,
        holidayConfig,
        project,
        weChat,
        department,
        report,
        contract,
        workHours,
        mindInfo,
        eteamChance,
        projectPerformance
    },
    // getters
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js